<template>
  <div id="achievements">
    <Title title="成果管理" />
    <ErrorMessage :status="listApiStatus.status" :customMessage="listApiStatus.customMessage" />

    <!-- 一覧 -->
    <AchievementList
      v-show="listApiStatus.status !== 0"
      :achievements="achievementList"
      :achievementFields="achievementFields"
      :showAll="true"
      @update="updateAchievementList"
    ></AchievementList>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Title from '@/components/Title.vue'
import ErrorMessage from '@/components/ErrorMessage.vue'
import AchievementList from '@/components/AchievementList.vue'
import { getAchievementFields } from '@/transformer/achievement'

export default {
  name: 'Achievements',
  components: {
    Title,
    ErrorMessage,
    AchievementList
  },

  computed: {
    ...mapState({
      listApiStatus: state => state.Achievement.listApiStatus,
      achievementTypes: state => state.Achievement.achievementTypes
    }),
    ...mapGetters('Achievement', ['achievementList']),
    ...mapGetters('Achievement', ['achievementOptions']),
    achievementFields() {
      return getAchievementFields(true, this.achievementOptions)
    }
  },

  methods: {
    updateAchievementList: function () {
      this.$store.dispatch('Achievement/getAchievementList')
    },
    getTypetalkToken() {
      // 認証ボタンクリック後、codeを元にトークンを取得してDBに保存
      const code = location.hash.match('code=(.*?)($|&)')
      if (code && code[1]) {
        this.$store.dispatch('typetalk/getNewToken', code[1]).then(() => {
          this.$root.$bvToast.toast('Typetalkと連携しました', {
            variant: 'success',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 3000
          })
          // vueにトークン保存
        }).catch(() => {
          this.$root.$bvToast.toast('Typetalkとの連携に失敗しました。', {
            variant: 'danger',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 3000
          })
        })
        return
      }

      const error = location.hash.match('error_reason=(.*?)[$|&]')
      if (error) {
        // typetalkの連携失敗
        let res = 'Typetalkとの連携に失敗しました。'
        if (error[1] === 'user_denied') {
          res = 'Typetalkとの連携が却下されました。'
        }
        this.$root.$bvToast.toast(res, {
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000
        })
      }
    }
  },
  mounted: function () {
    this.updateAchievementList()
    this.getTypetalkToken()
  }
}
</script>
